/**
 * API helpers for lead application form flow (CONTACTED → APPLICATION_FORM_FILLED).
 */
import { url } from "./url";
import { fetchWithAuth } from "./FetchWithAuth";

const API = `${url}/api/leads`;

/**
 * Upload form file and run OCR. Returns { status, warnings, data }.
 * @param {number} leadId - Enquiry/lead id
 * @param {File} file - PDF or image (jpg, jpeg, png)
 */
export async function ocrApplicationForm(leadId, file) {
  const formData = new FormData();
  formData.append("file", file);
  const response = await fetchWithAuth(`${API}/${leadId}/ocr-application-form`, {
    method: "POST",
    headers: {}, // let browser set Content-Type for FormData
    body: formData,
  });
  const json = await response.json();
  if (!response.ok) {
    throw new Error(json.error || "OCR request failed");
  }
  if (json.status === "error") {
    throw new Error(json.warnings?.[0] || "OCR failed");
  }
  return json;
}

/**
 * Store uploaded form file and get path for submit.
 * @param {number} leadId
 * @param {File} file
 * @returns {Promise<{ uploaded_document_path: string }>}
 */
export async function uploadApplicationFormFile(leadId, file) {
  const formData = new FormData();
  formData.append("file", file);
  const response = await fetchWithAuth(`${API}/${leadId}/upload-application-form-file`, {
    method: "POST",
    headers: {},
    body: formData,
  });
  const json = await response.json();
  if (!response.ok) {
    throw new Error(json.error || "Upload failed");
  }
  return json;
}

/**
 * Submit application form data and move lead to APPLICATION_FORM_FILLED.
 * @param {number} leadId
 * @param {Object} data - { name, phone, email, course, date, counsellor, uploaded_document_path? }
 */
export async function submitApplication(leadId, data) {
  const response = await fetchWithAuth(`${API}/${leadId}/submit-application`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(data),
  });
  const json = await response.json();
  if (!response.ok) {
    throw new Error(json.error || "Submit failed");
  }
  return json;
}
